import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { IUnleashConfig } from '@ideals/types';

import { FeatureToggleService } from './feature-toggle.service';

export function provideFeatureToggle(config: IUnleashConfig): EnvironmentProviders[] {
  return [
    provideAppInitializer(() => inject(FeatureToggleService).initialize(config)),
  ];
}
